<template>
	<Dialog
		v-model:visible="visible"
		:header="dialogTitle"
		:modal="true"
		:closable="true"
		:draggable="false"
		:style="{ width: '42rem' }"
	>
		<div v-if="isLoading" class="flex justify-content-center py-4">
			<ProgressSpinner style="width: 40px; height: 40px" />
		</div>
		<div v-else-if="events.length">
			<Timeline :value="events">
				<template #opposite="slotProps">
					<small class="text-500">{{ slotProps.item.date }}</small>
				</template>
				<template #content="slotProps">
					<div class="font-semibold mb-1">
						{{ slotProps.item.status }}
					</div>
					<div>{{ slotProps.item.actor }}</div>
					<div v-if="slotProps.item.notes" class="text-600 mt-1">
						{{ slotProps.item.notes }}
					</div>
				</template>
			</Timeline>
		</div>
		<div v-else class="text-600">Timeline tidak ditemukan.</div>
	</Dialog>
</template>

<script setup>
import { computed, defineExpose, defineProps, ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import InvoiceListProxyService from '../../service/InvoiceListProxyService';
import { mapInvoiceProxyTimelineEvents } from './invoiceProxyHistoryTimeline';

const props = defineProps({
	invoiceNo: {
		type: [String, Number],
		default: '',
	},
	vendorId: {
		type: [String, Number],
		default: null,
	},
	dbInstance: {
		type: String,
		default: 'COMET',
	},
	orgId: {
		type: [String, Number],
		default: null,
	},
});

const toast = useToast();
const visible = ref(false);
const isLoading = ref(false);
const events = ref([]);

const dialogTitle = computed(() =>
	props.invoiceNo ? `Timeline ${props.invoiceNo}` : 'Timeline Invoice'
);

const open = async () => {
	if (!props.invoiceNo || !props.vendorId || !props.orgId) {
		toast.add({
			severity: 'warn',
			summary: 'Timeline',
			detail: 'Data invoice tidak lengkap untuk cek timeline',
			life: 3000,
		});
		return;
	}

	events.value = [];
	visible.value = true;
	isLoading.value = true;

	try {
		const res = await InvoiceListProxyService.getHistoryTimeline({
			invoiceNo: props.invoiceNo,
			vendorId: props.vendorId,
			dbInstance: props.dbInstance || 'COMET',
			orgId: props.orgId,
		});

		// spb-invoice may wrap SnapX as { message, data: { message, data: { historyTimeline } } }
		events.value = mapInvoiceProxyTimelineEvents(res.data?.data ?? res.data);
	} catch (error) {
		toast.add({
			severity: 'error',
			summary: 'Gagal mengambil timeline',
			detail: error?.response?.data?.message || 'Terjadi kesalahan pada server',
			life: 3000,
		});
		visible.value = false;
	} finally {
		isLoading.value = false;
	}
};

defineExpose({ open });
</script>
